<template>
  <div class="row">
    <div :class="['col_12', { loading_overlay: loading }]">
      <div class="card no_border">
        <div class="card-header">
          <div class="d_flex_btwn form_action_btn width_full">
            <div class="card-title">{{ title }}</div>
            <router-link
              class="btn btn_blue ml_10"
              :to="{ name: 'exam_questions' }"
              >{{ $t('common.back') }}</router-link
            >
          </div>
        </div>
        <div :class="['card-body']">
          <div class="row">
            <div class="col_4">
              <div
                :class="['form-group', { has_error: errorFor('subject_id') }]"
              >
                <label>{{ $t('common.subject') }}</label>
                <select v-model="form.subject_id" class="form_global">
                  <option value="">{{ $t('common.select_subject') }}</option>
                  <option
                    :value="subject.id"
                    v-for="subject in subjects"
                    :key="'subject ' + subject.id"
                  >
                    {{ subject.name }}
                  </option>
                </select>
                <v-errors :errors="errorFor('subject_id')" />
              </div>
            </div>

            <div class="col_4">
              <div
                :class="[
                  'form-group',
                  { has_error: errorFor('question_type_id') },
                ]"
              >
                <label>{{ $t('common.question_type') }}</label>
                <select v-model="form.question_type_id" class="form_global">
                  <option value="">
                    {{ $t('common.select_question_type') }}
                  </option>
                  <option
                    :value="question_type.id"
                    v-for="question_type in question_types"
                    :key="'question_type ' + question_type.id"
                  >
                    {{ question_type.name }}
                  </option>
                </select>
                <v-errors :errors="errorFor('question_type_id')" />
              </div>
            </div>

            <!-- <div class="col_2">
              <div :class="['form-group', {'has_error': errorFor('folder_grade_id')}]">
                <label>{{ $t('common.folder_grade') }}</label>
                <select v-model="form.folder_grade_id" class="form_global">
                  <option value="">{{ $t('common.select_folder_grade') }}</option>
                  <option :value="folder_grade.id" v-for="folder_grade in folder_grades" :key="'folder_grade '+folder_grade.id">{{ folder_grade.name }}</option>
                </select>
                <v-errors :errors="errorFor('folder_grade_id')" />
              </div>
            </div>

            <div class="col_2">
              <div :class="['form-group', {'has_error': errorFor('folder_semester_id')}]">
                <label>{{ $t('common.folder_semester') }}</label>
                <select v-model="form.folder_semester_id" class="form_global">
                  <option value="">{{ $t('common.select_folder_semester') }}</option>
                  <option :value="folder_semester.id" v-for="folder_semester in folder_semesters" :key="'folder_semester '+folder_semester.id">{{ folder_semester.name }}</option>
                </select>
                <v-errors :errors="errorFor('folder_semester_id')" />
              </div>
            </div> -->

            <div class="col_4">
              <div
                :class="[
                  'form-group',
                  { has_error: errorFor('folder_unit_id') },
                ]"
              >
                <label>{{ $t('common.folder_unit') }}</label>
                <select v-model="form.folder_unit_id" class="form_global">
                  <option value="">
                    {{ $t('common.select_folder_unit') }}
                  </option>
                  <option
                    :value="folder_unit.id"
                    v-for="folder_unit in folder_units"
                    :key="'folder_unit ' + folder_unit.id"
                  >
                    {{ folder_unit.name }}
                  </option>
                </select>
                <v-errors :errors="errorFor('folder_unit_id')" />
              </div>
            </div>

            <div class="col_3 mt_20">
              <div
                :class="[
                  'form-group',
                  { has_error: errorFor('question_areas') },
                ]"
              >
                <label>{{ $t('common.area') }}</label>
                <Multiselect
                  v-model="areas"
                  mode="tags"
                  :placeholder="$t('common.select_area')"
                  :close-on-select="false"
                  :searchable="true"
                  :create-option="true"
                  :hideSelected="false"
                  :options="areaList"
                />
                <v-errors :errors="errorFor('question_areas')" />
              </div>
            </div>

            <div class="col_3 mt_20">
              <div :class="['form-group', { has_error: errorFor('grade_id') }]">
                <label>{{ $t('common.grade') }}</label>
                <select
                  v-model="form.grade_id"
                  class="form_global"
                  @change="loadUnitData()"
                >
                  <option value="">{{ $t('common.select_grade') }}</option>
                  <option
                    :value="item.id"
                    v-for="item in grades"
                    :key="'grade ' + item.id"
                  >
                    {{ item.name }}
                  </option>
                </select>
                <v-errors :errors="errorFor('grade_id')" />
              </div>
            </div>

            <div class="col_3 mt_20">
              <div
                :class="['form-group', { has_error: errorFor('semester_id') }]"
              >
                <label>{{ $t('sidebar.semesters.semesters') }}</label>
                <select
                  v-model="form.semester_id"
                  class="form_global"
                  @change="loadUnitData()"
                >
                  <option value="">{{ $t('common.select_semester') }}</option>
                  <option
                    :value="item.id"
                    v-for="item in semesters"
                    :key="'semester_id ' + item.id"
                  >
                    {{ item.name }}
                  </option>
                </select>
                <v-errors :errors="errorFor('semester_id')" />
              </div>
            </div>

            <div class="col_3 mt_20">
              <div :class="['form-group', { has_error: errorFor('unit_id') }]">
                <label>{{ $t('common.unit') }}</label>
                <select
                  v-model="form.unit_id"
                  class="form_global"
                  @change="unitsChange()"
                >
                  <option value="">{{ $t('common.select_unit') }}</option>
                  <!-- <option :value="item.id" v-for="item in units" :key="'unit_id '+item.id">{{ item.unit_name }} {{ item && item.unit_goal ? '- ' + unitGoal(item.unit_goal,40) : ''}}</option> -->
                  <option
                    :value="item.id"
                    v-for="item in units"
                    :key="'unit_id ' + item.id"
                  >
                    {{ item.unit_name }}
                  </option>
                </select>
                <v-errors :errors="errorFor('unit_id')" />
              </div>
            </div>

            <div class="col_3">
              <div
                :class="['form-group', { has_error: errorFor('car_time_id') }]"
              >
                <label>{{ $t('sidebar.unitManagement.car_city') }}</label>
                <select v-model="form.car_time_id" class="form_global">
                  <option value="">
                    {{ $t('common.select') }}
                    {{ $t('sidebar.unitManagement.car_city') }}
                  </option>
                  <option
                    :value="item.id"
                    v-for="item in cities"
                    :key="'car_time_id ' + item.id"
                  >
                    {{ item.name }}
                  </option>
                </select>
                <v-errors :errors="errorFor('car_time_id')" />
              </div>
            </div>

            <div class="col_3">
              <div
                :class="[
                  'form-group',
                  { has_error: errorFor('difficulty_id') },
                ]"
              >
                <label>{{ $t('sidebar.difficulty.difficulty') }}</label>
                <select v-model="form.difficulty_id" class="form_global">
                  <option value="">
                    {{ $t('sidebar.questions.select_difficulty') }}
                  </option>
                  <option
                    :value="difficulty.id"
                    v-for="difficulty in difficulties"
                    :key="'difficulty ' + difficulty.id"
                  >
                    {{ difficulty.name }}
                  </option>
                </select>
                <v-errors :errors="errorFor('difficulty_id')" />
              </div>
            </div>

            <div class="col_3">
              <div :class="['form-group', { has_error: errorFor('point_id') }]">
                <label>{{ $t('sidebar.point.point') }}</label>
                <select v-model="form.point_id" class="form_global">
                  <option value="">
                    {{ $t('sidebar.questions.select_point') }}
                  </option>
                  <option
                    :value="point.id"
                    v-for="point in points"
                    :key="'point ' + point.id"
                  >
                    {{ point.point }} {{ $t('sidebar.point.point') }}
                  </option>
                </select>
                <v-errors :errors="errorFor('point_id')" />
              </div>
            </div>

            <div class="col_3">
              <div :class="['form-group', { has_error: errorFor('status') }]">
                <label>{{ $t('common.status') }}</label>
                <div class="form_inline">
                  <div class="form_radio">
                    <input
                      type="radio"
                      id="waiting"
                      value="1"
                      v-model="form.status"
                    />
                    <label for="waiting">{{ $t('common.active') }}</label>
                  </div>
                  <div class="form_radio">
                    <input
                      type="radio"
                      id="posting"
                      value="0"
                      v-model="form.status"
                    />
                    <label for="posting">{{ $t('common.inactive') }}</label>
                  </div>
                </div>
                <v-errors :errors="errorFor('status')" />
              </div>
            </div>
          </div>

          <div class="row mt_20 mb_20">
            <div class="col_6">
              <div
                :class="[
                  'form-group',
                  { has_error: errorFor('question_type') },
                ]"
              >
                <label>{{ $t('sidebar.questions.question_type') }}</label>
                <div class="form_inline">
                  <div class="form_radio">
                    <input
                      type="radio"
                      id="multipleChoice"
                      value="multiple-choice"
                      @change="clearInput('multiple-choice')"
                      v-model="form.question_type"
                    />
                    <label for="multipleChoice">{{
                      $t('sidebar.questions.multiple_choice')
                    }}</label>
                  </div>
                  <div class="form_radio">
                    <input
                      type="radio"
                      id="shortAnswer"
                      value="short-answer"
                      @change="clearInput('short-answer')"
                      v-model="form.question_type"
                    />
                    <label for="shortAnswer">{{
                      $t('sidebar.questions.short_answer')
                    }}</label>
                  </div>
                  <div class="form_radio">
                    <input
                      type="radio"
                      id="descriptive"
                      value="descriptive"
                      @change="clearInput('descriptive')"
                      v-model="form.question_type"
                    />
                    <label for="descriptive">{{
                      $t('sidebar.questions.descriptive')
                    }}</label>
                  </div>
                </div>
                <v-errors :errors="errorFor('question_type')" />
              </div>
            </div>
          </div>

          <template v-if="form.question_type == 'multiple-choice'">
            <div class="row">
              <div
                :class="[
                  form.answers.length >= 4 ? 'col_3 more_col_items' : 'col_3',
                ]"
                v-for="(anwer, i) in form.answers"
                :key="'anser' + i"
              >
                <div class="video_upload_area">
                  <div class="video_upload_content">
                    <div class="visibility_status width_full">
                      <span
                        v-if="form.answers.length > 1"
                        class="close"
                        @click="removeMcq(i)"
                        ><img
                          src="/assets/images/cross--icon.png"
                          alt=""
                          class="width_full"
                      /></span>
                      <div :class="['form-group']">
                        <label class="mt_5">{{
                          $t('sidebar.questions.mcq1_answer_type')
                        }}</label>
                        <div class="form_inline">
                          <div class="form_radio">
                            <input
                              type="radio"
                              :id="'text_1' + i"
                              value="text"
                              v-model="form.answers[i].type"
                            />
                            <label :for="'text_1' + i">{{
                              $t('sidebar.questions.text')
                            }}</label>
                          </div>
                          <div class="form_radio">
                            <input
                              type="radio"
                              :id="'image_1' + i"
                              value="image"
                              v-model="form.answers[i].type"
                            />
                            <label :for="'image_1' + i">{{
                              $t('sidebar.questions.image')
                            }}</label>
                          </div>
                        </div>
                      </div>

                      <div :class="['form-group']">
                        <div class="form_checkbox">
                          <input
                            type="checkbox"
                            :id="'mcq_correct_answer_' + i"
                            v-model="form.answers[i].correct_answer"
                          />
                          <label :for="'mcq_correct_answer_' + i">{{
                            $t('sidebar.questions.correct_answer')
                          }}</label>
                        </div>
                      </div>

                      <div
                        v-if="form.answers[i].type == 'text'"
                        :class="[
                          'form-group',
                          { has_error: errorFor('answers.' + i + '.answer') },
                        ]"
                      >
                        <label
                          >{{
                            $t('sidebar.questions.answer_number_' + (i + 1))
                          }}
                        </label>
                        <text-editor-component
                          :id="'mcq_answer_' + i"
                          :existingData="form.answers[i].answer"
                          @change="changeEditorValue"
                        />
                        <v-errors
                          :errors="errorFor('answers.' + i + '.answer')"
                        />
                      </div>

                      <div
                        v-if="form.answers[i].type == 'image'"
                        :class="[
                          'form-group',
                          { has_error: errorFor('answers.' + i + '.answer') },
                        ]"
                      >
                        <label
                          >{{
                            $t('sidebar.questions.answer_number_' + (i + 1))
                          }}
                        </label>
                        <input
                          type="file"
                          class="form_global"
                          ref="mcq1_answer_image"
                          @change="attachmentUpload($event, i)"
                          accept="image/png, image/gif, image/jpeg"
                        />
                        <div
                          class="img_preview"
                          v-if="form.answers[i].image_path"
                        >
                          <img :src="form.answers[i].image_path" alt="" />
                        </div>
                        <v-errors
                          :errors="errorFor('answers.' + i + '.answer')"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                :class="[
                  form.answers.length >= 4 ? 'col_3 more_col_items' : 'col_3',
                ]"
                v-if="form.answers.length < 5"
              >
                <button
                  class="btn btn_blue ml_10 add_new_ans"
                  @click.prevent="addMcq()"
                >
                  +{{ $t('common.add') }}
                </button>
              </div>
            </div>
          </template>

          <div class="row" v-if="form.question_type == 'short-answer'">
            <div class="video_upload_area">
              <div class="video_upload_content">
                <div class="visibility_status width_full">
                  <div class="col_12">
                    <div
                      :class="[
                        'form-group',
                        { has_error: errorFor('short_answer_type') },
                      ]"
                    >
                      <label>{{ $t('common.short_answer_type') }}</label>
                      <div class="form_inline">
                        <div class="form_radio">
                          <input
                            type="radio"
                            id="general"
                            value="1"
                            v-model="form.short_answer_type"
                            @change="changeShortAnswerType()"
                          />
                          <label for="general">{{
                            $t('common.general')
                          }}</label>
                        </div>
                        <div class="form_radio">
                          <input
                            type="radio"
                            id="fractional"
                            value="2"
                            v-model="form.short_answer_type"
                            @change="changeShortAnswerType()"
                          />
                          <label for="fractional">{{
                            $t('common.fractional')
                          }}</label>
                        </div>
                      </div>
                      <v-errors :errors="errorFor('short_answer_type')" />
                    </div>
                  </div>
                  <template v-if="form.short_answer_type == 1">
                    <div class="col_12">
                      <div
                        :class="[
                          'form-group',
                          { has_error: errorFor('general_question_type') },
                        ]"
                      >
                        <label>Data Arrangement</label>
                        <div class="form_inline">
                          <div class="form_radio">
                            <input
                              type="radio"
                              id="sequence"
                              value="1"
                              v-model="form.general_question_type"
                              @change="changeGeneralAnswerType()"
                            />
                            <label for="sequence">Sequence</label>
                          </div>
                          <div class="form_radio">
                            <input
                              type="radio"
                              id="nonSequence"
                              value="2"
                              v-model="form.general_question_type"
                              @change="changeGeneralAnswerType()"
                            />
                            <label for="nonSequence">Non Sequence</label>
                          </div>
                        </div>
                        <v-errors :errors="errorFor('general_question_type')" />
                      </div>
                    </div>
                    <div class="col_12">
                      <div class="row">
                        <div class="col_3 custom_col_3">
                          <input
                            type="text"
                            :class="[
                              'form_global',
                              { custom_error: errorFor('general_input_one') },
                            ]"
                            v-model="form.general_input_one"
                          />
                        </div>
                        <div class="col_3 custom_col_3">
                          <input
                            type="text"
                            :class="[
                              'form_global',
                              { custom_error: errorFor('general_input_two') },
                            ]"
                            v-model="form.general_input_two"
                          />
                        </div>
                        <div class="col_3 custom_col_3">
                          <input
                            type="text"
                            :class="[
                              'form_global',
                              { custom_error: errorFor('general_input_three') },
                            ]"
                            v-model="form.general_input_three"
                          />
                        </div>
                        <div class="col_3 custom_col_3">
                          <input
                            type="text"
                            :class="[
                              'form_global',
                              { custom_error: errorFor('general_input_four') },
                            ]"
                            v-model="form.general_input_four"
                          />
                        </div>
                        <div class="col_3 custom_col_3">
                          <input
                            type="text"
                            :class="[
                              'form_global',
                              { custom_error: errorFor('general_input_five') },
                            ]"
                            v-model="form.general_input_five"
                          />
                        </div>
                      </div>
                    </div>
                  </template>
                  <template v-if="form.short_answer_type == 2">
                    <div class="col_12">
                      <div class="row">
                        <div class="col_12">
                          <div
                            :class="[
                              'form-group',
                              { has_error: errorFor('fractional_type') },
                            ]"
                          >
                            <label>{{ $t('common.fractional_type') }}</label>
                            <div class="form_inline">
                              <div class="form_radio">
                                <input
                                  type="radio"
                                  id="double"
                                  value="1"
                                  v-model="form.fractional_type"
                                  @change="changeFractionalType()"
                                />
                                <label for="double">{{
                                  $t('common.double')
                                }}</label>
                              </div>
                              <div class="form_radio">
                                <input
                                  type="radio"
                                  id="mixed"
                                  value="2"
                                  v-model="form.fractional_type"
                                  @change="changeFractionalType()"
                                />
                                <label for="mixed">{{
                                  $t('common.mixed')
                                }}</label>
                              </div>
                            </div>
                            <v-errors :errors="errorFor('fractional_type')" />
                          </div>
                        </div>
                        <div class="col_6" v-if="form.fractional_type == 1">
                          <div class="custom_fraction_input">
                            <div class="inner">
                              <input
                                type="text"
                                :class="[
                                  'form_global',
                                  {
                                    custom_error: errorFor(
                                      'fractional_input_one'
                                    ),
                                  },
                                ]"
                                v-model="form.fractional_input_one"
                              />
                              <div class="custom_border"></div>
                              <input
                                type="text"
                                :class="[
                                  'form_global',
                                  {
                                    custom_error: errorFor(
                                      'fractional_input_two'
                                    ),
                                  },
                                ]"
                                v-model="form.fractional_input_two"
                              />
                            </div>
                          </div>
                        </div>
                        <div class="col_6" v-if="form.fractional_type == 2">
                          <div class="custom_fraction_input">
                            <div class="inner width_full">
                              <input
                                type="text"
                                :class="[
                                  'form_global',
                                  {
                                    custom_error: errorFor(
                                      'fractional_input_three_custom'
                                    ),
                                  },
                                ]"
                                v-model="form.fractional_input_three_custom"
                              />
                            </div>
                            <div class="inner width_full">
                              <input
                                type="text"
                                :class="[
                                  'form_global',
                                  {
                                    custom_error: errorFor(
                                      'fractional_input_four_custom'
                                    ),
                                  },
                                ]"
                                v-model="form.fractional_input_four_custom"
                              />
                              <div class="custom_border"></div>
                              <input
                                type="text"
                                :class="[
                                  'form_global',
                                  {
                                    custom_error: errorFor(
                                      'fractional_input_five_custom'
                                    ),
                                  },
                                ]"
                                v-model="form.fractional_input_five_custom"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </div>

          <div class="row" v-if="form.question_type == 'descriptive'">
            <div class="col_12">
              <div
                :class="[
                  'form-group',
                  { has_error: errorFor('fingerprint_upload_type') },
                ]"
              >
                <label>지문 업로드 방식</label>
                <div class="form_inline">
                  <div class="form_radio">
                    <input
                      type="radio"
                      id="single"
                      value="single"
                      v-model="form.fingerprint_upload_type"
                    />
                    <label for="single">하나의</label>
                  </div>
                  <div class="form_radio">
                    <input
                      type="radio"
                      id="multiple"
                      value="multiple"
                      v-model="form.fingerprint_upload_type"
                    />
                    <label for="multiple">다수의</label>
                  </div>
                </div>
                <v-errors :errors="errorFor('descriptive_answer_type')" />
              </div>
            </div>
          </div>

          <div class="row" v-if="form.question_type == 'descriptive'">
            <div class="col_12">
              <div class="form-group">
                <label>{{ $t('sidebar.questions.answer') }} </label>
                <p>{{ $t('sidebar.questions.descriptive_answer') }}</p>
              </div>
            </div>
          </div>

          <div class="row" v-if="form.question_type == 'descriptive'">
            <div class="col_12">
              <div
                :class="[
                  'form-group',
                  { has_error: errorFor('descriptive_answer_type') },
                ]"
              >
                <label>{{
                  $t('sidebar.questions.descriptive_answer_type')
                }}</label>
                <div class="form_inline">
                  <div class="form_radio">
                    <input
                      type="radio"
                      id="writing"
                      value="writing"
                      v-model="form.descriptive_answer_type"
                    />
                    <label for="writing">{{
                      $t('sidebar.questions.writing')
                    }}</label>
                  </div>
                  <div class="form_radio">
                    <input
                      type="radio"
                      id="drawing"
                      value="drawing"
                      v-model="form.descriptive_answer_type"
                    />
                    <label for="drawing">{{
                      $t('sidebar.questions.drawing')
                    }}</label>
                  </div>
                </div>
                <v-errors :errors="errorFor('descriptive_answer_type')" />
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col_6">
              <div :class="['form-group', { has_error: errorFor('title') }]">
                <label>{{ $t('sidebar.questions.title') }}</label>
                <text-editor-component
                  :id="'title'"
                  :existingData="form.title ? form.title : ''"
                  @change="changeEditorValue"
                />
                <v-errors :errors="errorFor('title')" />
              </div>
            </div>
            <div class="col_6">
              <div
                :class="[
                  'form-group',
                  { has_error: errorFor('learning_goal') },
                ]"
              >
                <label>{{ $t('sidebar.lectureCommon.learning_goal') }}</label>
                <text-editor-component
                  :id="'learning_goal'"
                  :existingData="form.learning_goal ? form.learning_goal : ''"
                  @change="changeEditorValue"
                />
                <v-errors :errors="errorFor('learning_goal')" />
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col_6" v-if="form.fingerprint_upload_type == 'single'">
              <div
                :class="['form-group', { has_error: errorFor('fingerprint') }]"
                v-if="form.question_type == 'descriptive'"
              >
                <label>{{ $t('sidebar.questions.fingerprint') }}</label>
                <text-editor-component
                  :id="'fingerprint'"
                  :descriptive="'descriptive'"
                  :existingData="form.fingerprint ? form.fingerprint : ''"
                  @change="changeEditorValue"
                />
                <v-errors :errors="errorFor('fingerprint')" />
              </div>
              <div
                :class="['form-group', { has_error: errorFor('fingerprint') }]"
                v-else
              >
                <label>{{ $t('sidebar.questions.fingerprint') }}</label>
                <text-editor-component
                  :id="'fingerprint'"
                  :descriptive="''"
                  :existingData="form.fingerprint ? form.fingerprint : ''"
                  @change="changeEditorValue"
                />
                <v-errors :errors="errorFor('fingerprint')" />
              </div>
            </div>
            <div class="col_6">
              <div
                :class="['form-group', { has_error: errorFor('admin_note') }]"
              >
                <label>{{ $t('sidebar.questions.admin_note') }}</label>
                <text-editor-component
                  :id="'admin_note'"
                  :existingData="form.admin_note ? form.admin_note : ''"
                  @change="changeEditorValue"
                />
                <v-errors :errors="errorFor('admin_note')" />
              </div>
            </div>
          </div>

          <div class="row" v-if="form.fingerprint_upload_type == 'single'">
            <div class="col_6">
              <div
                :class="[
                  'form-group',
                  { has_error: errorFor('commentary_type') },
                ]"
              >
                <label>{{ $t('common.commentary_type') }}</label>
                <div class="form_inline">
                  <div class="form_radio">
                    <input
                      type="radio"
                      id="editor"
                      value="1"
                      v-model="form.commentary_type"
                    />
                    <label for="editor">{{ $t('common.editor') }}</label>
                  </div>
                  <div class="form_radio">
                    <input
                      type="radio"
                      id="video_type"
                      value="2"
                      v-model="form.commentary_type"
                    />
                    <label for="video_type">{{ $t('common.video') }}</label>
                  </div>
                </div>
                <v-errors :errors="errorFor('commentary_type')" />
              </div>
              <div class="row">
                <template v-if="form.commentary_type == 1">
                  <div
                    class="col_12"
                    v-if="form.question_type == 'descriptive'"
                  >
                    <div
                      :class="[
                        'form-group',
                        { has_error: errorFor('commentary') },
                      ]"
                    >
                      <label>{{ $t('sidebar.questions.commentary') }}</label>
                      <text-editor-component
                        :id="'commentary'"
                        :descriptive="'descriptive'"
                        :existingData="form.commentary ? form.commentary : ''"
                        @change="changeEditorValue"
                      />
                      <v-errors :errors="errorFor('commentary')" />
                    </div>
                  </div>
                  <div class="col_12" v-else>
                    <div
                      :class="[
                        'form-group',
                        { has_error: errorFor('commentary') },
                      ]"
                    >
                      <label>{{ $t('sidebar.questions.commentary') }}</label>
                      <text-editor-component
                        :id="'commentary'"
                        :descriptive="''"
                        :existingData="form.commentary ? form.commentary : ''"
                        @change="changeEditorValue"
                      />
                      <v-errors :errors="errorFor('commentary')" />
                    </div>
                  </div>
                </template>
                <template v-else>
                  <div class="col_12" v-if="question_preview_videos.length">
                    <div class="video_list">
                      <div
                        class="inner"
                        v-for="(
                          preview_video, index
                        ) in question_preview_videos"
                        :key="index"
                      >
                        <div class="inner_wrap">
                          <img
                            :src="preview_video.thumbs"
                            alt=""
                            v-if="preview_video.convert_status == 'Completed'"
                          />
                          <img
                            :src="baseUrl + 'assets/images/no_image.jpg'"
                            alt=""
                            v-else
                          />
                          <div class="icons">
                            <span
                              v-if="preview_video.smil"
                              @click.prevent="showVideo(preview_video.smil)"
                              ><i class="lni lni-eye"></i
                            ></span>
                            <span
                              ><i
                                class="lni lni-trash"
                                @click.prevent="removeVideo(preview_video)"
                              ></i
                            ></span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col_12">
                    <div
                      :class="[
                        'form-group',
                        { has_error: errorFor('video_upload') },
                      ]"
                    >
                      <label>{{
                        $t('sidebar.lectureCommon.video_upload')
                      }}</label>
                      <div class="form_inline">
                        <div class="form_radio">
                          <input
                            type="radio"
                            id="uploadVideo"
                            value="2"
                            v-model="video_upload_type"
                            @change="changeVideoUploadType()"
                          />
                          <label for="uploadVideo">URL</label>
                        </div>
                        <div class="form_radio">
                          <input
                            type="radio"
                            id="uploadUrl"
                            value="1"
                            v-model="video_upload_type"
                            @change="changeVideoUploadType()"
                          />
                          <label for="uploadUrl">{{
                            $t('common.video')
                          }}</label>
                        </div>
                      </div>
                      <template v-if="video_upload_type == 1">
                        <vue-dropzone
                          ref="upload_dropzone"
                          id="upload_dropzone"
                          :class="{ dropzone_disable: dropzoneDisable }"
                          @vdropzone-removed-file="vremoved"
                          @vdropzone-success-multiple="vSuccessMultiple"
                          :options="dropzoneOptions"
                          :duplicateCheck="true"
                        >
                        </vue-dropzone>
                        <v-errors :errors="errorFor('question_videos')" />
                      </template>
                      <template v-if="video_upload_type == 2">
                        <div
                          :class="[
                            'form-group',
                            { has_error: errorFor('video_url') },
                          ]"
                        >
                          <input
                            type="text"
                            class="form_global"
                            v-model="form.question_video_url"
                          />
                          <v-errors :errors="errorFor('video_url')"></v-errors>
                        </div>
                      </template>

                      <div class="form-group" style="width: 230px">
                        <label>{{ $t('sidebar.exams.video_intro') }}</label>
                        <input
                          type="number"
                          v-model="form.video_intro"
                          class="form_global"
                        />
                      </div>
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col_12" v-if="multipleFingerprintList.length">
              <div class="d_flex_start mt_20 mb_20">
                <h4>Finger Print & Commentary List</h4>
              </div>
              <div class="table_responsive">
                <table class="table">
                  <thead>
                    <tr>
                      <th>Commentary Type</th>
                      <th>{{ $t('common.action') }}</th>
                    </tr>
                  </thead>
                  <tbody v-if="multipleFingerprintList.length">
                    <tr
                      v-for="(fingerprint, index) in multipleFingerprintList"
                      :key="'fingerprint_' + index"
                    >
                      <td>
                        {{
                          fingerprint.commentary_type === 1 ? 'Text' : 'Video'
                        }}
                      </td>
                      <td>
                        <button
                          class="btn btn_blue ml_10 question_remove"
                          @click="editFingerprint(index)"
                        >
                          <img
                            :src="`${baseUrl}assets/media/images/icon/8.png`"
                            alt=""
                          />
                        </button>
                        <button
                          class="btn btn_blue ml_10 question_remove"
                          @click="removeFingerprint(index)"
                        >
                          <img
                            :src="`${baseUrl}assets/media/images/icon/9.png`"
                            alt=""
                          />
                        </button>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td colspan="8">{{ $t('common.no_data_msg') }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div class="d_flex_end">
            <button
              class="btn btn_md btn_common"
              v-if="form.fingerprint_upload_type == 'multiple'"
              @click.prevent="openFingerprintModal()"
            >
              Finger Print
            </button>
            <button class="btn btn_md btn_blue ml_20" @click.prevent="submit()">
              {{ $t('common.save') }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <video-modal
      v-if="videoModalShow"
      :showVideoModal="videoModalShow"
      :video="videoSmilFile"
      @closeModal="closeModal()"
    ></video-modal>

    <fingerprint-modal
      v-if="fingerprintModalShow"
      :showFingerprintModal="fingerprintModalShow"
      @fingerprintData="fingerprintData"
      :fingerprint="fingerprint"
      @closeModal="closeModal()"
    >
    </fingerprint-modal>
  </div>
</template>

<script>
import TextEditorComponent from '@/components/TextEditorComponent';
import vueDropzone from '../../lecture_management/components/dropzone';
import VideoModal from '../../lecture_management/components/VideoModal';
import FingerprintModal from '../questions/FingerprintModal.vue';
import Multiselect from '@vueform/multiselect';
import Mathml2latex from 'mathml-to-latex';

export default {
  components: {
    TextEditorComponent,
    vueDropzone,
    VideoModal,
    FingerprintModal,
    Multiselect,
  },
  data() {
    return {
      baseUrl: process.env.VUE_APP_BASE,
      title: this.$t('sidebar.questions.add_question'),
      difficulties: [],
      points: [],
      subjects: [],
      question_types: [],
      folder_grades: [],
      folder_semesters: [],
      folder_units: [],
      semesters: [],
      grades: [],
      units: [],
      cities: [],
      areaList: [],
      mcqOne: true,
      mcqTwo: false,
      mcqThree: false,
      mcqFour: false,
      mcqFive: false,
      form: {
        difficulty_id: '',
        point_id: '',
        subject_id: '',
        question_type_id: '',
        folder_grade_id: '',
        folder_semester_id: '',
        folder_unit_id: '',
        grade_id: '',
        semester_id: '',
        unit_id: '',
        car_time_id: '',
        question_type: 'multiple-choice',
        mcq_correct_answer: '',
        short_answer_type: '1',
        fractional_type: '1',
        general_input_one: '',
        general_input_two: '',
        general_input_three: '',
        general_input_four: '',
        general_input_five: '',
        fractional_input_one: '',
        fractional_input_two: '',
        fractional_input_three_custom: '',
        fractional_input_four_custom: '',
        fractional_input_five_custom: '',
        short_answer_formula: '',
        descriptive_answer_type: 'writing',
        fingerprint_upload_type: 'single',
        title: '',
        learning_goal: '',
        fingerprint: '',
        commentary: '',
        admin_note: '',
        status: '1',
        commentary_type: '1',
        images: [],
        answers: [
          {
            question_id: 2,
            sort: 1,
            type: 'text',
            answer: '',
            formula: '',
            correct_answer: false,
          },
        ],
        question_video_url: '',
        video_intro: '',
        general_question_type: 1,
      },
      areas: [],
      question_videos: [],
      question_preview_videos: [],
      dropzoneOptions: {
        url: `${process.env.VUE_APP_API_BASE_URL}/upload/video`,
        thumbnailWidth: 150,
        maxFiles: 1,
        maxFilesize: 5368709120,
        uploadMultiple: true,
        allowMultiple: true,
        addRemoveLinks: true,
        acceptedFiles: 'video/*',
        headers: {
          Authorization:
            `Bearer ` + JSON.parse(localStorage.getItem('admin')).token,
        },
      },
      dropzoneDisable: false,
      videoModalShow: false,
      videoSmilFile: null,
      video_upload_type: 2,
      fingerprintModalShow: false,
      multipleFingerprintList: [],
      editFingerprintIndex: null,
      fingerprint: '',
    };
  },
  created() {
    this.axios
      .get('/difficulties')
      .then((response) => (this.difficulties = response.data.data));
    this.axios
      .get('/points')
      .then((response) => (this.points = response.data.data));
    this.axios
      .get('/subjects')
      .then((response) => (this.subjects = response.data.data));
    this.axios
      .get('/question_types')
      .then((response) => (this.question_types = response.data.data));
    this.axios
      .get('/folder_grades')
      .then((response) => (this.folder_grades = response.data.data));
    this.axios
      .get('/folder_semesters')
      .then((response) => (this.folder_semesters = response.data.data));
    this.axios
      .get('/folder_units')
      .then((response) => (this.folder_units = response.data.data));
    this.axios
      .get('/grades')
      .then((response) => (this.grades = response.data.data));
    this.axios
      .get('/semesters')
      .then((response) => (this.semesters = response.data.data));
    // this.axios.get('/units').then((response) => this.units = response.data.data);

    this.axios.get('/areas').then((response) => {
      let questionArea = response.data.data;

      if (questionArea) {
        questionArea.forEach((element) => {
          let questionAreaList = {
            value: element.id,
            label: element.name,
          };
          this.areaList.push(questionAreaList);
        });
      }
    });

    if (this.$route.name === 'exam_questions_edit') {
      this.axios.get('/questions/' + this.$route.params.id).then((response) => {
        let questionData = response.data.data;
        this.form = questionData;
        this.cities =
          questionData.unit &&
          questionData.unit.carcity &&
          questionData.unit.carcity.length
            ? questionData.unit.carcity
            : [];
        this.form.difficulty_id = questionData.difficulty
          ? questionData.difficulty.id
          : '';
        this.form.point_id = questionData.point ? questionData.point.id : '';
        this.form.subject_id = questionData.subject
          ? questionData.subject.id
          : '';
        this.form.question_type_id = questionData.question_type_relation
          ? questionData.question_type_relation.id
          : '';
        this.form.folder_grade_id = questionData.folder_grade
          ? questionData.folder_grade.id
          : '';
        this.form.folder_semester_id = questionData.folder_semester
          ? questionData.folder_semester.id
          : '';
        this.form.folder_unit_id = questionData.folder_unit
          ? questionData.folder_unit.id
          : '';
        this.form.grade_id = questionData.grade ? questionData.grade.id : '';
        this.form.semester_id = questionData.semester
          ? questionData.semester.id
          : '';
        this.form.unit_id = questionData.unit ? questionData.unit.id : '';
        this.form.car_time_id = questionData.carcity
          ? questionData.carcity.id
          : '';

        if (questionData.fingerprint_upload_type == 'multiple') {
          this.form.fingerprint_upload_type = 'multiple';
          let QuestionFingerprintData = questionData.fingerprints;
          if (QuestionFingerprintData) {
            let fingerPrintData = [];
            QuestionFingerprintData.forEach((element) => {
              if (element.videos && element.videos.length) {
                if (element.videos[0].video_url) {
                  let data = {
                    commentary: element.commentary,
                    commentary_type: element.commentary_type,
                    fingerprint: element.fingerprint,
                    question_video_url: element.videos[0].video_url,
                    video_intro: element.videos[0].video_intro,
                    question_video: '',
                    video_upload_type: 2,
                  };

                  fingerPrintData.push(data);
                } else {
                  let questionOriginalFile = {
                    original_file: element.videos[0].original_filename,
                    file: '',
                  };
                  let data = {
                    commentary: element.commentary,
                    commentary_type: element.commentary_type,
                    fingerprint: element.fingerprint,
                    question_video_url: '',
                    video_intro: '',
                    question_video: questionOriginalFile,
                    video_upload_type: 1,
                  };
                  fingerPrintData.push(data);
                }
              } else {
                let data = {
                  commentary: element.commentary,
                  commentary_type: element.commentary_type,
                  fingerprint: element.fingerprint,
                  question_video_url: '',
                  video_intro: '',
                  question_video: '',
                  video_upload_type: '',
                };
                fingerPrintData.push(data);
              }
            });
            this.multipleFingerprintList = fingerPrintData;
          }
        } else {
          this.form.fingerprint_upload_type = 'single';
        }

        this.editUnitData();

        if (questionData.question_type == 'short-answer') {
          if (questionData.fractional_type == 1) {
            this.form.fractional_input_one = questionData.fractional_input_one;
            this.form.fractional_input_two = questionData.fractional_input_two;
          }
          if (questionData.fractional_type == 2) {
            this.form.fractional_input_three_custom =
              questionData.fractional_input_one;
            this.form.fractional_input_four_custom =
              questionData.fractional_input_two;
            this.form.fractional_input_five_custom =
              questionData.fractional_input_three;
          }
        }

        if (questionData.areas) {
          let areaData = [];
          questionData.areas.forEach((element) => {
            areaData.push(element.area_id);
          });

          this.areas = areaData;
        }

        let questionVideoList = questionData.question_videos;
        this.question_preview_videos = questionVideoList;

        if (questionVideoList) {
          questionVideoList.forEach((element) => {
            if (element.video_url) {
              this.form.question_video_url = element.video_url;
              this.form.video_intro = element.video_intro;
              this.video_upload_type = 2;
            }

            if (element.video_url == null) {
              let questionOriginalFile = {
                original_file: element.original_filename,
                file: '',
              };
              this.question_videos.push(questionOriginalFile);
              this.video_upload_type = 1;
            }
          });
        }
      });
      this.title = this.$t('sidebar.questions.edit_question');
    }
  },
  methods: {
    vremoved(file) {
      let filename = this.question_videos.find((object) => {
        return object.original_file === file.name;
      });
      this.axios
        .post('/delete-lecture-local-video', { name: filename.file })
        .then(() => {
          this.showSuccessMsg('Video Removed Successfully!');
          let index = this.question_videos.findIndex((object) => {
            return object.original_file === file.name;
          });
          if (index !== -1) {
            this.question_videos.splice(index, 1);
          }
        });
    },
    vSuccessMultiple(file, response) {
      response.forEach((element, index) => {
        let questionOriginalFile = {
          original_file: file[index].name,
          file: element.original_filename,
        };
        this.question_videos.push(questionOriginalFile);
      });
    },
    showVideo(smil) {
      this.videoSmilFile = smil;
      this.videoModalShow = true;
    },
    closeModal() {
      this.videoModalShow = false;
      this.fingerprintModalShow = false;
    },
    removeVideo(video) {
      let questionId = video.id;
      this.axios.post('/delete-question-video', { id: questionId }).then(() => {
        this.showSuccessMsg('Video Removed Successfully!');
        var questionIndex = this.question_videos.find((object) => {
          return object.original_file === video.original_file;
        });
        if (questionIndex !== -1) {
          this.question_videos.splice(questionIndex, 1);
        }
        var questionPreviewIndex = this.question_preview_videos.findIndex(
          (object) => {
            return object.id === video.id;
          }
        );
        if (questionPreviewIndex !== -1) {
          this.question_preview_videos.splice(questionPreviewIndex, 1);
        }
      });
    },
    changeEditorValue(editorId, data) {
      if (editorId === 'mcq_answer_0') {
        this.form.answers[0].answer = data;
      } else if (editorId === 'mcq_answer_1') {
        this.form.answers[1].answer = data;
      } else if (editorId === 'mcq_answer_2') {
        this.form.answers[2].answer = data;
      } else if (editorId === 'mcq_answer_3') {
        this.form.answers[3].answer = data;
      } else if (editorId === 'mcq_answer_4') {
        this.form.answers[4].answer = data;
      } else {
        this.form[editorId] = data;
      }
    },
    addMcq() {
      this.form.answers.push({
        question_id: null,
        sort: 1,
        type: 'text',
        answer: '',
        formula: '',
        correct_answer: false,
      });
    },
    removeMcq(index) {
      if (this.form.answers.length > 1) this.form.answers.splice(index, 1);
    },
    unitsChange() {
      this.form.car_time_id = '';
      let id = this.form.unit_id;

      if (id) {
        let unit = this.units.find((i) => i.id === id);

        if (unit && unit.carcity.length) {
          this.cities = unit.carcity;
        }
      } else {
        this.cities = [];
      }
    },
    clearInput(value) {
      switch (value) {
        case 'multiple-choice':
          this.resetShortAnswer();
          this.form.short_answer_formula = '';
          this.form.descriptive_answer_type = 'writing';
          if (!this.form.answers.length) {
            this.form.answers.push({
              question_id: 2,
              sort: 1,
              type: 'text',
              answer: '',
              formula: '',
              correct_answer: false,
            });
          }
          break;

        case 'short-answer':
          this.form.descriptive_answer_type = 'writing';
          this.resetMcq();
          break;

        case 'descriptive':
          this.resetShortAnswer();
          this.form.short_answer_formula = '';
          this.resetMcq();
          break;

        default:
          break;
      }
    },
    changeShortAnswerType() {
      this.form.general_input_one = '';
      this.form.general_input_two = '';
      this.form.general_input_three = '';
      this.form.general_input_four = '';
      this.form.general_input_five = '';
      this.form.fractional_input_one = '';
      this.form.fractional_input_two = '';
      this.form.fractional_input_three_custom = '';
      this.form.fractional_input_four_custom = '';
      this.form.fractional_input_five_custom = '';
    },
    changeGeneralAnswerType() {
      this.form.general_input_one = '';
      this.form.general_input_two = '';
      this.form.general_input_three = '';
      this.form.general_input_four = '';
      this.form.general_input_five = '';
      this.form.fractional_input_one = '';
      this.form.fractional_input_two = '';
      this.form.fractional_input_three_custom = '';
      this.form.fractional_input_four_custom = '';
      this.form.fractional_input_five_custom = '';
    },
    changeFractionalType() {
      this.form.general_input_one = '';
      this.form.general_input_two = '';
      this.form.general_input_three = '';
      this.form.general_input_four = '';
      this.form.general_input_five = '';
      this.form.fractional_input_one = '';
      this.form.fractional_input_two = '';
      this.form.fractional_input_three_custom = '';
      this.form.fractional_input_four_custom = '';
      this.form.fractional_input_five_custom = '';
    },
    resetShortAnswer() {
      this.form.short_answer_type = '1';
      this.form.fractional_type = '1';
      this.form.general_input_one = '';
      this.form.general_input_two = '';
      this.form.general_input_three = '';
      this.form.general_input_four = '';
      this.form.general_input_five = '';
      this.form.fractional_input_one = '';
      this.form.fractional_input_two = '';
      this.form.fractional_input_three_custom = '';
      this.form.fractional_input_four_custom = '';
      this.form.fractional_input_five_custom = '';
    },
    resetMcq() {
      this.mcqTwo = false;
      this.mcqThree = false;
      this.mcqFour = false;
      this.mcqFive = false;
    },
    attachmentUpload(event, index) {
      let files = event.target.files || event.dataTransfer.files;

      if (!files.length) return;

      this.form.answers[index].answer = event.target.files[0];
    },
    changeVideoUploadType() {
      if (this.video_upload_type == 1) {
        this.form.question_video_url = '';
        this.form.video_intro = '';
      } else {
        this.question_videos = [];
      }
    },
    submit() {
      this.allErrors = null;
      this.loading = true;

      if (this.$route.name === 'exam_questions_edit') {
        this.loading = true;
        this.errors = null;

        let formData = new FormData();

        Object.keys(this.form).forEach((key) => {
          formData.append(key, this.form[key] ? this.form[key] : '');
        });

        if (this.form.question_type === 'multiple-choice') {
          window.$.each(this.form.answers, function (i, inv) {
            formData.append('answers[' + i + '][question_id]', inv.question_id);
            formData.append('answers[' + i + '][id]', inv.id ? inv.id : null);
            formData.append('answers[' + i + '][sort]', inv.sort);
            formData.append('answers[' + i + '][type]', inv.type);
            formData.append('answers[' + i + '][answer]', inv.answer);
            formData.append(
              'answers[' + i + '][formula]',
              inv.formula && inv.formula != 'null' ? inv.formula : ''
            );
            formData.append(
              'answers[' + i + '][correct_answer]',
              inv.correct_answer ? 1 : 0
            );
            formData.append(
              'images[' + i + ']',
              inv.type === 'image' ? inv.answer : 'no-image'
            );
          });
        } else {
          formData.append('answers', []);
        }

        formData.append(
          'question_videos',
          JSON.stringify(this.question_videos)
        );
        formData.append('question_areas', JSON.stringify(this.areas));
        formData.append(
          'multiple_fingerprint',
          JSON.stringify(this.multipleFingerprintList)
        );

        formData.append('_method', 'PATCH');

        this.axios
          .post('/questions/' + this.$route.params.id, formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          })
          .then(() => {
            this.$router.push({ name: 'exam_questions' });
            this.showSuccessMsg(this.$t('common.updateSuccess'));
          })
          .catch((err) => {
            this.allErrors = err.response.data.errors;
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        let formData = new FormData();

        Object.keys(this.form).forEach((key) => {
          formData.append(key, this.form[key] ? this.form[key] : '');
        });

        window.$.each(this.form.answers, function (i, inv) {
          formData.append('answers[' + i + '][question_id]', inv.question_id);
          formData.append('answers[' + i + '][sort]', inv.sort);
          formData.append('answers[' + i + '][type]', inv.type);
          formData.append('answers[' + i + '][answer]', inv.answer);
          formData.append('answers[' + i + '][formula]', inv.formula);
          formData.append(
            'answers[' + i + '][correct_answer]',
            inv.correct_answer
          );
          formData.append(
            'images[' + i + ']',
            inv.type === 'image' ? inv.answer : 'no-image'
          );
        });

        if (this.form.question_type != 'multiple-choice') {
          formData.append('answers', []);
        }

        formData.append(
          'question_videos',
          JSON.stringify(this.question_videos)
        );
        formData.append('question_areas', JSON.stringify(this.areas));
        formData.append(
          'multiple_fingerprint',
          JSON.stringify(this.multipleFingerprintList)
        );

        this.axios
          .post('/questions', formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          })
          .then(() => {
            this.$router.push({ name: 'exam_questions' });
            this.showSuccessMsg(this.$t('common.addSuccess'));
          })
          .catch((err) => {
            this.allErrors = err.response.data.errors;
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    loadUnitData() {
      let grade_id = this.form.grade_id;

      if (grade_id == '') {
        this.units = '';
        this.cities = '';
        this.form.unit_id = '';
        this.form.car_time_id = '';
      }

      let semester_id = this.form.semester_id;

      if (semester_id == '') {
        this.form.unit_id = '';
        this.form.car_time_id = '';
        this.units = '';
        this.cities = '';
      }

      if (grade_id && semester_id) {
        this.units = '';
        this.cities = '';
        this.form.unit_id = '';
        this.form.car_time_id = '';
        this.axios
          .post('/load-unit-data/', {
            grade_id: grade_id,
            semester_id: semester_id,
          })
          .then((response) => {
            let unitData = response.data.data;
            this.units = unitData;
            if (unitData && unitData.length < 1) {
              this.form.unit_id = '';
              this.form.car_time_id = '';
              this.units = '';
              this.cities = '';
            }
          });
      }
    },
    editUnitData() {
      let grade_id = this.form.grade_id;

      if (grade_id == '') {
        this.units = '';
        this.cities = '';
        this.form.unit_id = '';
        this.form.car_time_id = '';
      }

      let semester_id = this.form.semester_id;

      if (semester_id == '') {
        this.form.unit_id = '';
        this.form.car_time_id = '';
        this.units = '';
        this.cities = '';
      }

      if (grade_id && semester_id) {
        this.axios
          .post('/load-unit-data/', {
            grade_id: grade_id,
            semester_id: semester_id,
          })
          .then((response) => {
            let unitData = response.data.data;
            this.units = unitData;
            if (unitData && unitData.length < 1) {
              this.form.unit_id = '';
              this.form.car_time_id = '';
              this.units = '';
              this.cities = '';
            }
          });
      }
    },
    unitGoal(text, length) {
      if (text.length > length) {
        return text.substring(0, length) + '...';
      } else {
        return text;
      }
    },
    openFingerprintModal() {
      this.editFingerprintIndex = null;
      this.fingerprint = '';
      this.fingerprintModalShow = true;
    },
    fingerprintData(data) {
      if (data) {
        let index = this.editFingerprintIndex;
        if (index != null && index > -1) {
          this.multipleFingerprintList.splice(index, 1, data);
        } else {
          this.multipleFingerprintList.push(data);
        }
      }
    },
    editFingerprint(index) {
      this.editFingerprintIndex = index;
      this.fingerprint = '';
      this.fingerprint = this.multipleFingerprintList[index];
      this.fingerprintModalShow = true;
    },
    removeFingerprint(index) {
      this.multipleFingerprintList.splice(index, 1);

      this.editFingerprintIndex = null;
    },
    convertTextEditor(string) {
      let parser = new DOMParser();
      const doc = parser.parseFromString(string, 'text/html');
      let mathTags = doc.getElementsByTagName('math');
      if (mathTags.length > 0) {
        [...mathTags].forEach((mathTag) => {
          mathTag.replaceWith(this.getLatex(mathTag.outerHTML));
        });
        return doc.body.innerHTML.replace(/<img[^>]*>/g, '');
      } else {
        return string ? string.replace(/<img[^>]*>/g, '') : '';
      }
    },
    getLatex(mathTag) {
      try {
        let latex = Mathml2latex.convert(mathTag);
        latex = this.sanitizeLatex(latex);
        latex = `\\[${latex}\\]`; // for block math
        return latex;
      } catch (error) {
        console.error('Latex conversion failed:', error);
        return mathTag; // fallback: keep original MathML
      }
    },
    sanitizeLatex(latex) {
      return latex
        .replace(/&nbsp;/g, ' ') // remove non-breaking spaces
        .replace(/\\left\\\(\\right\.\s*/g, '\\left(') // fix left paren
        .replace(/\s*\\left\.\s*\\right\\\)/g, '\\right)') // fix right paren
        .replace(/\s{2,}/g, ' ') // remove extra spaces
        .trim();
    },
    __getLatex(mathTag) {
      let latex = Mathml2latex.convert(mathTag);
      latex = '$$' + latex + '$$';
      latex = latex.replace(/\+\b/g, '\\\\');
      return latex;
    },
  },
};
</script>
<style scoped>
.close {
  position: absolute;
  right: 17px;
  top: 0;
  width: 15px;
  height: 15px;
  cursor: pointer;
}
.more_col_items {
  flex: 0 0 20%;
  max-width: 20%;
}
.add_new_ans {
  top: 30%;
}
.custom_error {
  border: 1px solid red;
}
.question_remove {
  height: auto;
  padding: 5px 20px;
}
.question_remove img {
  width: 17px;
}
.video_upload_area .video_upload_content {
  max-width: 1000px;
}
.custom_col_3 {
  max-width: 20%;
}
</style>
<style src="@vueform/multiselect/themes/default.css"></style>
